import { constants } from './constants';

export const routesPath = {
    ROOT: {
        PATH: '/',
        // USERS_LIST: '/users-list',
        // SETTINGS: '/settings',
        USER_SETTINGS: '/user-settings',
        DASHBOARD: '/dashboard',
        // EXPORT_PDF: '/export-pdf',
        // FILE_UPLOAD: '/file-upload',
        // ORDERS: '/orders',
        // CART: '/cart',
        // PAYMENTS: '/payments',
        // SUBSCRIPTIONS: '/subscriptions',
        // TEAM: '/team',
        // CREATE_TEAM: '/create-team-app',
        // CREATE_TEAM_AUTH: '/create-team',
        // BUSINESSES: '/businesses',
        // LEADS: '/leads',
        // RECENT_UPDATES: '/recent-updates',
        PAYMENT: '/payment',
        PROFILE: '/profile',
        HELP: '/help',
        REPORT: '/report/:id',
        INTERNAL_REPORT: '/internal-report/:vin',
        COMBINED_REPORT: '/combined-report/:vin/:id',
        SELECT_REPORT: '/select-report',
        TRANSACTIONS: '/transactions',
        CONGRATULATIONS: '/congratulations',
    },
    AUTH: {
        PATH: '/auth',
        SIGN_IN: 'sign-in',
        CALLBACK: 'callback',
        FORGOT_PASSWORD: 'forgot-password',
        RESTORE_PASSWORD: 'restore-password/:token',
        TWO_FACTOR_AUTH: 'two-factor-authentication',
        INVITATION: 'invitation/:token',
    },
    ERROR: {
        PATH: '/error',
    },
    PUBLIC: {
        SAMPLE_REPORT: '/sample-report',
        SHARED_REPORT: '/shared-report/:sharedLink',
        COMBINED_REPORT_EXAMPLE: '/combined-report-sample',
        INTERNAL_REPORT_EXAMPLE: '/internal-report-sample',
        EXTENSION_CONFIDENCE_PRIVACY_POLICY: '/extension-confidence-privacy-policy',
        PRIVACY_AND_TERMS: '/privacy-and-terms',
        IMPERSONATE: '/impersonate',
        UNSUBSCRIBE: '/unsubscribe',
    },
    FOOTER: {
        INTERCODE: 'https://intercode.com',
        DASHBOARD: '/dashboard',
        PAYMENT: '/payment',
        BLOG: `${constants.LANDING_BASE_URL}/blog`,
        BLOG_ARCHIVE: `${constants.LANDING_BASE_URL}/archive`,
        ABOUT_US: `${constants.LANDING_BASE_URL}/about`,
        CONTACT: `${constants.LANDING_BASE_URL}/contact`,
        FAQ: `${constants.LANDING_BASE_URL}/faq`,
        SUPPORT: `${constants.LANDING_BASE_URL}/support`,
        GUIDES: `${constants.LANDING_BASE_URL}/guides`,
        PRIVACY_POLICY: `${constants.LANDING_BASE_URL}/privacy`,
        COOKIE_STATEMENT: `${constants.LANDING_BASE_URL}/cookies`,
        SAMPLE_REPORT: '/sample-report',
    },
};
